import { fetchWithAuth, getCSRFToken } from '../auth';

const API = process.env.REACT_APP_ICC_TOOL_API_HOST;

const jsonHeaders = () => ({
    'X-CSRFToken': getCSRFToken(),
    'Content-Type': 'application/json',
});

export const getTeamTypes = () =>
    fetchWithAuth(`${API}team-types/`, {
        method: 'GET',
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include',
    });

export const createTeamType = (data) =>
    fetch(`${API}team-types/`, {
        method: 'POST',
        headers: jsonHeaders(),
        credentials: 'include',
        body: JSON.stringify(data),
    });

export const updateTeamType = (id, data) =>
    fetch(`${API}team-types/${id}/`, {
        method: 'PATCH',
        headers: jsonHeaders(),
        credentials: 'include',
        body: JSON.stringify(data),
    });
